import React from 'react';

export default function RequiredLabel() {
	return (
		<span className="requiredSpan">*</span>
	);
}
